module.exports = __webpack_public_path__ + "img/banner.22ed6f29.png";